import { UIFlightData } from "@flights/types";
import useCreateUrl from "hooks/useCreateUrl";
import { useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useActions } from "../../store";
import { trackCustomGoal } from "utils/et";
import { PRE_OPTED_ANCILLARIES_QUERY_PARAMS } from "../../constants";
import { actions as extraProductActions } from "ancillaries/store/extraProducts/actions";
import useOfferCartOrderData from "hooks/useOfferCartOrderData";
import useGetSearchResultsBound from "hooks/useGetSearchResultsBound";

export default function useGoToFlightDetails() {
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const params = useParams<{ airports: string; outboundToken: string }>();
  const { createUrl } = useCreateUrl();
  const history = useHistory();
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const actions = useActions(extraProductActions);
  const offerCartOrderData = useOfferCartOrderData();
  const bound = useGetSearchResultsBound();

  return useCallback(
    (
      flightToken: string,
      baseOffer: UIFlightData,
      brandedFareIndex?: number,
      withFlexTicket?: boolean,
      withCfarTicket?: Boolean
    ) => {
      const isBrandedFare = baseOffer.token !== flightToken;

      const locationParams = location.search;

      trackCustomGoal("flights_apex_branded_fare_from_cache_web", 3); // Click fare card
      const urlParams = new URLSearchParams(locationParams);

      urlParams.set("baseOfferToken", baseOffer.token);
      if (brandedFareIndex !== undefined && Number.isInteger(brandedFareIndex)) {
        urlParams.set("brandedFareIndex", brandedFareIndex.toString());
      }

      if (withFlexTicket && !isBrandedFare) {
        urlParams.set(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket, "true");
        actions.addPreOptInProduct("flexibleTicket", true);
      } else if (withCfarTicket && !isBrandedFare) {
        urlParams.set(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.cancelForAnyReason, "true");
        actions.addPreOptInProduct("cancelForAnyReason", true);
      } else {
        urlParams.delete(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket);
        urlParams.delete(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.cancelForAnyReason);
        actions.removePreOptInProduct("flexibleTicket");
        actions.removePreOptInProduct("cancelForAnyReason");
      }

      offerCartOrderData.set(flightToken, { offer: flightToken, parentOfferToken: baseOffer.token });

      let url = `/flights/${params.airports}/${flightToken}/?${urlParams}`;

      /* start - flights_split_bounds_us */
      // Check if we are on a Split Bounds page.
      if (bound && params.outboundToken) {
        url = `/flights/${params.airports}/inbound/${params.outboundToken}/${flightToken}/?${urlParams}`;
      }
      /* end - flights_split_bounds_us */

      history.push(createUrl(url));
    },
    [offerCartOrderData, params.airports, params.outboundToken, bound, history, createUrl, actions]
  );
}
